import { useApiStore } from '@/stores/apiStore';
import { OrgJoinRequestsApi } from '@/../generated-client/apis/OrgJoinRequestsApi';
import { JoinRequestAction } from '../../generated-client/models';

let orgJoinRequestsApi: OrgJoinRequestsApi | null = null;
let lastConfig: unknown = null;

function getOrgJoinRequestsApi(): OrgJoinRequestsApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (orgJoinRequestsApi === null || lastConfig !== apiConfig) {
    orgJoinRequestsApi = new OrgJoinRequestsApi(apiConfig);
    lastConfig = apiConfig;
  }

  return orgJoinRequestsApi;
}

export const cancelMyJoinRequest = async () => {
  const api = getOrgJoinRequestsApi();

  return await api.apiOrgJoinRequestsCancelMyJoinRequestDelete();
};

export const getAllJoinRequests = async () => {
  const api = getOrgJoinRequestsApi();

  return await api.apiOrgJoinRequestsGetAllJoinRequestsGet();
};

export const getMyPendingJoinRequest = async () => {
  const api = getOrgJoinRequestsApi();

  return await api.apiOrgJoinRequestsGetMyPendingJoinRequestGet();
};

export const processJoinRequests = async (
  orgCode: string,
  actions: JoinRequestAction[],
) => {
  const api = getOrgJoinRequestsApi();

  return await api.apiOrgJoinRequestsProcessJoinRequestsPut({
    processJoinRequestsModel: {
      org_code: orgCode,
      actions: actions,
    },
  });
};
